import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { Menu, MenuItem, Stack } from "@mui/material";

import CallUsNow from "../common/CallUsNow";
import DialogBox from "../common/DialogBox";
import soc2 from "../../assets/footer/soc2_logo.WebP";
import csiLogo from "../../assets/footer/csi_logo.webp";
import PlainAlertMessage from "../common/PlainAlertMessage";
import Youtube_Icon from "../../assets/articles/youtube.svg";
import ContactUsForm from "../attorney-program/ContactUsForm";
import Facebook_Icon from "../../assets/articles/facebook.svg";
import LinkedIn_Icon from "../../assets/articles/linkedln.svg";
import BBB2 from "../../assets/leadpage/family_img_bedge.WebP";
import Instagram_Icon from "../../assets/articles/instagram.svg";
import footerLogo from "../../assets/footer/equity_grayscale.WebP";
import { agentsAdminAction } from "../../redux/slices/brokers/agentAdminSlice";
import {
  decryptPayload,
  getObjLength,
  navigateToCustomerDomain,
} from "../helpers/utils";
import {
  BBB_REVIEW_LINK,
  DEFAULT_URL,
  EP_ADDRESS,
  Gorka30,
  Mike30,
  Prager30,
} from "../helpers/constants";
import {
  ATTORNEY_SUPPORT_PHONE,
  ATTORNEY_SUPPORT_PHONE_FORMAT,
  FACEBOOK_LINK,
  INSTAGRAM_LINK,
  LINKEDIN_LINK,
  ROLES,
  SUBDOMAIN,
  YOUTUBE_LINK,
} from "../helpers/constants";

import "../../styles/footer.scss";

const Footer = ({
  isTryPage = false,
  isAttorneyRoute = false,
  isInvestors = false,
  isSiteMap = true,
  hide_footerlinks = false,
  hide_footer_CTA = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const path = window.location.pathname;
  const promocode_source = path?.includes("gorka")
    ? Gorka30
    : path?.includes("gallagher")
    ? Mike30
    : false;
  let promocode = promocode_source
    ? promocode_source
    : path?.includes("prager")
    ? Prager30
    : null;

  const { contactformData } = useSelector((state) => state?.agentsAdmin);

  const [isProgramModal, setIsProgramModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const closeContactUsModal = () => {
    setIsProgramModal(false);
    dispatch(agentsAdminAction.fetchUserContactData({}));
  };

  // handle My Account Button
  const handleMyAccountBtn = () => {
    if (isTryPage) {
      window.location.href = `${DEFAULT_URL}login`;
    } else {
      let user = localStorage.getItem("authorised");
      // let userRole = userSignInDetails?.data?.role;
      let userRole = decryptPayload(localStorage.getItem("roles"));
      if (
        user === "true" &&
        (userRole?.includes(ROLES.admin) ||
          userRole?.includes(ROLES.subAdmin) ||
          userRole?.includes(ROLES.provider) ||
          userRole?.includes(ROLES.countyRecorder))
      ) {
        navigate("/admin-profile");
      } else if (
        user === "true" &&
        (userRole?.includes(ROLES.customer) ||
          userRole?.includes(ROLES.secondaryUser))
      ) {
        navigate("/user-profile");
      } else if (user === "true" && userRole?.includes(ROLES.serviceProvider)) {
        navigate("/servicer-profile");
      } else {
        navigate("/login");
      }
    }
  };

  const handleRedirect = (route = "/") => {
    window.location.href = `${DEFAULT_URL}${route}`;
  };
  const pathname = window.location.pathname;
  const is_scrp_hp = localStorage.getItem("scrp_hp");
  let countyCode = decryptPayload(localStorage.getItem("county-code"));

  const isMenuOpen = Boolean(anchorEl);
  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget); // Open the dropdown on hover
  };

  const handleMouseLeave = () => {
    setAnchorEl(null); // Close the dropdown when mouse leaves
  };

  useEffect(() => {
    const handleWheel = (event) => {
      if (event.deltaY < 0) {
        // Mouse scrolled up
        handleMouseLeave();
      }
    };

    window.addEventListener("wheel", handleWheel);
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <section className="footer_body">
      <Container fluid className="mx-150">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div className="w-100 d-flex justify-content-center align-items-center">
                <LazyLoadImage
                  src={footerLogo}
                  className="footer_logo mx-3"
                  alt="footerLogo"
                  style={{ width: "200px", height: "100%" }}
                />
                {is_scrp_hp && (
                  <LazyLoadImage
                    src={csiLogo}
                    className="footer_logo mx-3"
                    alt="footerLogo"
                    style={{ width: "66px", height: "72px" }}
                  />
                )}
              </div>

              {!hide_footerlinks && (
                <Nav className="footer_nav">
                  {window.location.hostname
                    .split(".")[0]
                    ?.includes(SUBDOMAIN.servicer) &&
                  window.location.hostname.split(".")[0] !== "staging" ? (
                    <>
                      <Link
                        className={`text-uppercase`}
                        style={{ padding: "0 27.5px" }}
                        onClick={() => navigateToCustomerDomain("")}
                      >
                        Home
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link
                        className="text-uppercase"
                        style={{ padding: "0 27.5px" }}
                        to={
                          !isTryPage
                            ? isInvestors
                              ? "/investor-login"
                              : is_scrp_hp
                              ? `/county-recorder/${countyCode}`
                              : isAttorneyRoute
                              ? "/attorney-title-program"
                              : "/"
                            : "#"
                        }
                        onClick={() =>
                          isTryPage ? handleRedirect("home") : null
                        }
                      >
                        Home
                      </Link>
                      {!isInvestors ? (
                        <>
                          {isAttorneyRoute ? (
                            <Link
                              className="text-uppercase"
                              style={{ padding: "0 27.5px" }}
                              to={
                                !isTryPage
                                  ? "/attorney-title-program/premier-protection"
                                  : "#"
                              }
                              onClick={() =>
                                isTryPage
                                  ? handleRedirect(
                                      "attorney-title-program/premier-protection"
                                    )
                                  : null
                              }
                            >
                              WHAI IS PREMIER PROTECTION
                            </Link>
                          ) : (
                            <div
                              className="title_theft_div"
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                            >
                              <span
                                className="title_theft_footer"
                                style={{ padding: "0 27.5px" }}
                              >
                                How it Works
                              </span>

                              <Menu
                                anchorEl={anchorEl}
                                open={isMenuOpen}
                                onClose={handleMouseLeave}
                                className="footer_menuItems"
                                MenuListProps={{
                                  onMouseLeave: handleMouseLeave,
                                }}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                sx={{
                                  "& .MuiPaper-root": {
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                  },
                                }}
                                disableScrollLock
                              >
                                <Link
                                  className="text-decoration-none"
                                  to={!isTryPage ? "/how-it-works" : "#"}
                                  onClick={handleMouseLeave}
                                >
                                  <MenuItem
                                    className="text-uppercase navbar-menu-texts"
                                    onClick={handleMouseLeave}
                                  >
                                    How it Works
                                  </MenuItem>
                                </Link>
                                <Link
                                  className="text-decoration-none"
                                  to="/property-risk-management"
                                >
                                  <MenuItem
                                    className="text-uppercase navbar-menu-texts"
                                    onClick={handleMouseLeave}
                                  >
                                    Property Risk Management
                                  </MenuItem>
                                </Link>
                              </Menu>
                            </div>
                          )}

                          <Link
                            className="text-uppercase"
                            style={{ padding: "0 27.5px" }}
                            to={`${is_scrp_hp ? "/" + countyCode : ""}/pricing${
                              promocode ? "?" + promocode : ""
                            }`}
                            // to={!isTryPage ? "/pricing" : "#"}
                            onClick={() =>
                              isTryPage ? handleRedirect("pricing") : null
                            }
                          >
                            Pricing
                          </Link>
                        </>
                      ) : null}
                      {!isAttorneyRoute && (
                        <Link
                          className="text-uppercase"
                          style={{ padding: "0 27.5px" }}
                          to={`/news`}
                          onClick={() =>
                            isTryPage ? handleRedirect("news") : null
                          }
                        >
                          EquityProtect in the News
                        </Link>
                      )}
                      {!isAttorneyRoute && (
                        <Link
                          className="text-uppercase"
                          style={{ padding: "0 27.5px" }}
                          to={`/blog`}
                          onClick={() =>
                            isTryPage ? handleRedirect("blog") : null
                          }
                        >
                          Blog
                        </Link>
                      )}
                    </>
                  )}
                  {isInvestors && (
                    <Link
                      className="text-uppercase"
                      style={{ padding: "0 27.5px" }}
                      to={`/investor-pricing`}
                      onClick={() =>
                        isTryPage ? handleRedirect("investors-pricing") : null
                      }
                    >
                      Pricing
                    </Link>
                  )}
                  {!is_scrp_hp && !isInvestors && !isAttorneyRoute && (
                    <Link
                      className="text-uppercase"
                      style={{ padding: "0 27.5px" }}
                      to={!isTryPage ? "/for-service-provider" : "#"}
                      onClick={() =>
                        isTryPage
                          ? handleRedirect("for-service-provider")
                          : null
                      }
                    >
                      For Service providers
                    </Link>
                  )}
                  {isSiteMap && !isAttorneyRoute && (
                    <Link
                      className="text-uppercase"
                      to={!isTryPage ? "/sitemap" : "#"}
                      onClick={() =>
                        isTryPage ? handleRedirect("sitemap") : null
                      }
                    >
                      Sitemap
                    </Link>
                  )}
                  {isAttorneyRoute && (
                    <div
                      className="title_theft_div"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <span
                        className="title_theft_footer"
                        style={{ padding: "0 27.5px" }}
                      >
                        Title Theft
                      </span>

                      <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        className="footer_menuItems"
                        onClose={handleMouseLeave}
                        MenuListProps={{
                          onMouseLeave: handleMouseLeave,
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        sx={{
                          "& .MuiPaper-root": {
                            borderRadius: "4px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                        disableScrollLock
                      >
                        <Link
                          to="/attorney-title-program/what-is-home-title-theft"
                          className="text-decoration-none"
                        >
                          <MenuItem
                            className="text-uppercase navbar-menu-texts"
                            onClick={handleMouseLeave}
                          >
                            What is Title Theft?
                          </MenuItem>
                        </Link>
                        <Link
                          to="/attorney-title-program/title-protection-long-time-homeowners"
                          className="text-decoration-none"
                        >
                          <MenuItem
                            className="text-uppercase navbar-menu-texts"
                            onClick={handleMouseLeave}
                          >
                            Risks for Homeowners
                          </MenuItem>
                        </Link>
                        <Link
                          to="/attorney-title-program/title-protection-real-estate-investors"
                          className="text-decoration-none"
                        >
                          <MenuItem
                            className="text-uppercase navbar-menu-texts"
                            onClick={handleMouseLeave}
                          >
                            {" "}
                            Risks for Real Estate Investors{" "}
                          </MenuItem>
                        </Link>
                      </Menu>
                    </div>
                  )}
                </Nav>
              )}
              {!hide_footer_CTA && (
                <div className="d-flex justify-content-center pb-4">
                  {isAttorneyRoute || isAttorneyRoute ? (
                    <>
                      <div className="atrny_btn_direction atrny_btn_direction_footer">
                        <button
                          className="atrny_btn__ button_clr m-2"
                          onClick={() => setIsProgramModal(true)}
                        >
                          Contact me to Explore Program
                        </button>

                        <button className="atrny_btn__ call_btn m-2">
                          <a href={`tel:${ATTORNEY_SUPPORT_PHONE}`}>
                            Call us now at {ATTORNEY_SUPPORT_PHONE_FORMAT}
                          </a>
                        </button>

                        <button
                          className="atrny_btn__ vdo_btn m-2"
                          onClick={() => {
                            window.open(
                              `https://www.youtube.com/watch?v=1hw9FC4ZYWs`,
                              "_blank"
                            );
                          }}
                        >
                          Watch a brief Video of the Program
                        </button>
                      </div>
                    </>
                  ) : (
                    <CallUsNow
                      type={"text"}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    />
                  )}
                  {!isAttorneyRoute && !isAttorneyRoute && (
                    <button
                      className="m-2 footer_btn footer_green"
                      onClick={handleMyAccountBtn}
                    >
                      My Account
                    </button>
                  )}
                </div>
              )}
              <Stack
                direction={"row"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                className=" pt-2"
                paddingBottom={1}
                sx={{}}
              >
                <a
                  href={INSTAGRAM_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="px-2"
                >
                  <img
                    src={Instagram_Icon}
                    alt="Facebook"
                    style={{ height: "35px" }}
                  />
                  {/* <InstagramIcon style={{ color: "#E4405F" }} fontSize="large" /> */}
                </a>

                <a
                  href={FACEBOOK_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="px-2"
                >
                  <img
                    src={Facebook_Icon}
                    alt="Facebook"
                    style={{ height: "35px" }}
                  />
                  {/* <FacebookIcon fontSize="large" /> */}
                </a>
                <a
                  href={LINKEDIN_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="px-2"
                >
                  <img
                    src={LinkedIn_Icon}
                    alt="Linkedln"
                    style={{ height: "35px" }}
                  />
                </a>
                <a
                  href={YOUTUBE_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="px-2"
                >
                  <img
                    src={Youtube_Icon}
                    alt="Youtube"
                    style={{ height: "50px", width: "45px" }}
                  />
                </a>
              </Stack>

              <div className="coyright_bar">
                <p className="my-2">
                  © {new Date().getFullYear()} EquityProtect, Inc. All rights
                  reserved
                </p>
                <p className="mb-0">EquityProtect Inc. - {EP_ADDRESS}</p>
              </div>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                gap={2}
                className="align-items-center mt-3"
              >
                <a href={BBB_REVIEW_LINK} target="_blank" rel="noreferrer">
                  <LazyLoadImage
                    src={BBB2}
                    className="footer_logo"
                    alt="bbbLogo"
                    style={{
                      width: "auto",
                      height: "60px",
                    }}
                  />
                </a>
                <LazyLoadImage
                  src={soc2}
                  className="footer_logo"
                  alt="soc2Logo"
                  style={{
                    width: "auto",
                    height: "90px",
                  }}
                />
              </Stack>
              <hr className="separator" />
            </div>
          </Col>
        </Row>
      </Container>

      {/* Contact form */}
      {isProgramModal && (
        <DialogBox
          title={
            (!getObjLength(contactformData) || !contactformData?.success) &&
            "Contact form"
          }
          contentClassName={"bg-white p-0"}
          openPopup={isProgramModal}
          setOpenPopup={setIsProgramModal}
          onClose={
            getObjLength(contactformData) && contactformData?.success
              ? false
              : closeContactUsModal
          }
          content={
            !getObjLength(contactformData) || !contactformData?.success ? (
              <div className="property_form">
                <ContactUsForm />{" "}
              </div>
            ) : (
              <PlainAlertMessage
                type="Success"
                openPopup={true}
                onClose={true}
                onCloseFun={closeContactUsModal}
                message={contactformData?.message}
                footer={false}
              />
            )
          }
        />
      )}
    </section>
  );
};

export default React.memo(Footer);
